import { render, staticRenderFns } from "./scoring_criteria.vue?vue&type=template&id=8252f368&scoped=true&"
import script from "./scoring_criteria.vue?vue&type=script&lang=js&"
export * from "./scoring_criteria.vue?vue&type=script&lang=js&"
import style0 from "./scoring_criteria.vue?vue&type=style&index=0&id=8252f368&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8252f368",
  null
  
)

export default component.exports